<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>设备编号：</label>
                <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                                    <el-table-column prop="code" label="设备编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="factory_code" label="出厂编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="flowmeter_code11" label="进浆流量计" sortable="custom"></el-table-column>
                                    <el-table-column prop="flowmeter_code12" label="回浆流量计" sortable="custom"></el-table-column>
                                    <el-table-column prop="flowmeter_code2" label="压力计" sortable="custom"></el-table-column>
                                    <el-table-column prop="flowmeter_code3" label="密度计" sortable="custom"></el-table-column>
                                    <el-table-column prop="flowmeter_code4" label="下位机" sortable="custom"></el-table-column>
                                    <el-table-column prop="router_code" label="路由器" sortable="custom"></el-table-column>
                                    <el-table-column prop="check_code" label="关联数据采集器" sortable="custom"></el-table-column>
                                    <el-table-column prop="state" label="状态" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.device_state, "device_state") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="240" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <DeviceUser
                                width="800px"
                                :device_id="model_id"
                                :device_type="device_type"
                                title="关联报警用户"
                                :isshow="dushow"
                                @on-close="closeDeviceUserDialog">
                            </DeviceUser>
                            <RelationDevice
                                width="800px"
                                :id="model_id"
                                title="关联配件"
                                :isshow="relation_device_show"
                                @on-close="closeRelationDeviceDialog">
                            </RelationDevice>
                            <Borrow
                                width="600px"
                                :id="model_id"
                                title="设备借调"
                                :isshow="borrow_show"
                                @on-close="closeBorrowDialog">
                            </Borrow>
        </div>
    </el-card>
</div>
        <Edit
                            width="600px"
                            :id="model_id"
                            :title="edit_title"
                            :isshow="editshow"
                            @on-close="closeEditDialog"
                            @on-save-ok="saveOk">
                        </Edit>
                        <Info
                            width="600px"
                            :id="model_id"
                            title="查看非接触设备"
                            :isshow="infoshow"
                            @on-close="closeInfoDialog">
                        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import DeviceUser from "../deviceuser/list"
import RelationDevice from "./relationdevice"
import Borrow from "./borrow.vue"
import listutil from "@/libs/listutil"

export default {
    name: 'dExtractList',
    mixins: [listutil],
    components: {Edit, Info, DeviceUser, Btns, LabBtns, RelationDevice, Borrow},
    data() {
        return {
            m_name: '非接触设备',
            menu_id: 3270,
            list_url: "/api/admin/deviceextract/list",
            search_Obj: {
                f_code: '',
                f_name: '',
                f_check_code: '',
            },
            del_Obj:{
                url:'/api/admin/deviceextract/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_state'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            dushow: false,
            device_type: 3,
            relation_device_show: false,
            borrow_show: false,
        };
    },
    methods: {
        relationUser(index, row){
            this.model_id = row.id
            this.dushow = true
        },
        closeDeviceUserDialog() {
            this.dushow = false
        },
        relationDevice(index, row){
            this.model_id = row.id
            this.relation_device_show = true
        },
        closeRelationDeviceDialog() {
            this.relation_device_show = false
            this.getListData()
        },
        borrow(index, row){
            this.model_id = row.id
            this.borrow_show = true
        },
        closeBorrowDialog(){
            this.borrow_show = false
            this.getListData()
        },
        add(){
            this.relation_device_show = true
            this.model_id = -1
            this.edit_title = "添加" + this.m_name
        },
    }
};
</script>